export const ALAPADATOK = 0;
export const DIJ_ADATOK = 1;
export const BIZTOSITOTTAK_ADATAI = 2;
export const SZERZODO_ADATOK = 3;
export const BEFEJEZES = 4;
export const NYILATKOZATOK = 5;
export const AJANLATI_ADATOK = 6;

export const BALESET_ALAPADATOK = 0;
export const BALESET_DIJAK = 1;
export const BALESET_SZERZODO_ADATOK = 2;
export const BALESET_BIZTOSITOTTAK_ADATAI = 3;
export const BALESET_NYILATKOZATOK = 4;
export const BALESET_BEFEJEZES = 5;
export const BALESET_SIGNAL_ONLINE_PASSWORD = 10;

export const GAP_ALAPADATOK = 0;
export const GAP_DIJAK = 1;
export const GAP_SZERZODO_ADATOK = 2;
export const GAP_GEPJARMU_ADATAI = 3;
export const GAP_NYILATKOZATOK = 4;
export const GAP_BEFEJEZES = 5;

export const KGFB_ALAPADATOK = 0;
export const KGFB_DIJAK = 1;
export const KGFB_AJANLATI_ADATOK = 2;
export const KGFB_NYILATKOZATOK = 3;
export const KGFB_AJANLAT = 4;

export const TORZS = 1024;

export const AZONOSITAS = 0;
export const OSSZEGZES = 1;

export const SCENARIOS = [
    ALAPADATOK,
    DIJ_ADATOK,
    BIZTOSITOTTAK_ADATAI,
    SZERZODO_ADATOK,
    BEFEJEZES,
    AJANLATI_ADATOK,
    NYILATKOZATOK,
    BALESET_ALAPADATOK,
    BALESET_DIJAK,
    BALESET_SZERZODO_ADATOK,
    BALESET_BIZTOSITOTTAK_ADATAI,
    BALESET_NYILATKOZATOK,
    BALESET_BEFEJEZES,
    GAP_ALAPADATOK,
    GAP_DIJAK,
    GAP_SZERZODO_ADATOK,
    GAP_GEPJARMU_ADATAI,
    GAP_NYILATKOZATOK,
    GAP_BEFEJEZES,
];
